/**
 * A legenda das zonas SBTn ou do SBTn modificado (spec 07 §6.3): a cor nunca vai sozinha — cada zona com
 * o número e o nome escritos ao lado (no 2016, também a sigla). As cores são os tokens do motor
 * (`var(--ts-sbtn-N)`, `var(--ts-sbtnmod-N)`). Com `presentes`, as zonas que a vertical não tem ficam
 * esmaecidas e dizem isso. `titulo` troca o título (o SBT usa as mesmas zonas; no Schneider e no Qt1 × Bq a
 * legenda é a da cor dos pontos, a zona SBTn). `soPresentes` (onda 315: a legenda da trilha pintada pela zona)
 * lista só as zonas que a vertical tem.
 */
import type { JSX } from 'react';
import { ZONAS_SBTN, ZONAS_SBTN_MOD } from '../motor';

/** A legenda de um ábaco de zonas: SBTn (1 a 9) ou SBTn modificado (1 a 7). */
export function LegendaSbt(p: {
  tipo: 'sbtn' | 'sbtnMod'; presentes?: ReadonlySet<number>; titulo?: string; soPresentes?: boolean;
}): JSX.Element {
  const zonas = p.tipo === 'sbtn'
    ? (Object.entries(ZONAS_SBTN) as [string, { token: string; nome: string }][]).map(([n, z]) => ({
      numero: Number(n), token: z.token, texto: z.nome,
    }))
    : (Object.entries(ZONAS_SBTN_MOD) as [string, { token: string; nome: string; sigla: string }][]).map(([n, z]) => ({
      numero: Number(n), token: z.token, texto: `${z.sigla} · ${z.nome}`,
    }));
  const titulo = p.titulo ?? (p.tipo === 'sbtn' ? 'Zonas SBTn (Robertson 1990)' : 'Zonas do SBTn modificado (Robertson 2016)');
  return (
    <figure className="cptu-legenda" aria-label={titulo}>
      <figcaption className="cptu-legenda-titulo">{titulo}</figcaption>
      <ul>
        {zonas.filter((z) => !p.soPresentes || !p.presentes || p.presentes.has(z.numero)).map((z) => {
          const ausente = p.presentes !== undefined && !p.presentes.has(z.numero);
          return (
            <li key={z.numero} className={ausente ? 'ausente' : undefined}>
              <svg className="cptu-amostra-da-zona" width="14" height="14" aria-hidden="true">
                <rect width="14" height="14" fill={`var(${z.token})`} />
              </svg>
              <span>
                <b>{z.numero}</b> · {z.texto}
                {ausente ? <span className="cptu-nota"> (não ocorre nesta vertical)</span> : null}
              </span>
            </li>
          );
        })}
      </ul>
    </figure>
  );
}
